import SidebarTemplate from "components/templates/SidebarTemplate";
import React, { useState } from "react";
import CustomizeReportLayout from "components/organismos/master/storeManagement/report/CustomizeReportLayout";

const DEFAULT_PAGE_TITLE = "カスタマイズ帳票";

const CustomizeReportPage = () => {
  // 独立メニューの場合は帳票名（メニュー名）を画面タイトルに表示する
  const [pageTitle, setPageTitle] = useState(DEFAULT_PAGE_TITLE);

  return (
    <SidebarTemplate pageTitle={pageTitle}>
      <CustomizeReportLayout onTitleChange={setPageTitle} />
    </SidebarTemplate>
  );
};
export default CustomizeReportPage;
